import Api from "@/services/Api";

export default {
	async all({ groupId, caseId } = {}) {
		const params = Object.assign({ limit: 100 }, groupId ? { "group_id": groupId } : { "storechain": "tls-app-hads" });

		return Api().get(`/tls/groups/cases/${caseId}/comments`, { params	})
			.then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async create({ groupId, caseId, message }) {
		const data   = new FormData();
		const url    = `/tls/groups/cases/${caseId}/comments`;
		const params = Object.assign({}, groupId ? { "group_id": groupId } : { "storechain": "tls-app-hads" });

		data.set("comment[body]", message.body);
		data.set("comment[private]", message.private);

		return Api()({
			method: "post",
			url:    url,
			data:   data,
			params: params 
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async destroy(caseId, id) {
		return Api().delete(`/tls/groups/cases/${caseId}/comments/${id}`, {
			params: {
				storechain: "tls-app-hads"
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async chart() {
		return Api().get("/tls/groups/cases/comments/chart", {
			params: {
				storechain: "tls-app-hads"
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async stats() {
		return Api().get("/tls/groups/cases/comments/stats", {
			params: {
				storechain: "tls-app-hads"
			}
		}).then(response => response.data)
			.catch(error => Promise.reject(error));
	},
};